<template>
  <div class="profil-container">
    <h3 class="profil-title">Terima Kasih</h3>
    <p class="profil-subtitle" v-if="!$store.state.landingpage.registerDone">
      Silahkan tekan tombol selesai untuk di process ke tahap selanjutnya
    </p>
    <p class="profil-subtitle" v-if="$store.state.landingpage.registerDone">
      Informasi dan Dokumen yang telah Anda submit sedang kami review lebih
      lanjut. Mohon selalu cek emailnya bertahap untuk notifikasi lebih lanjut
      dari kami.
    </p>

    <div class="profil-btn-wrapper" v-if="!$store.state.landingpage.registerDone">
      <div @click="registerVendor()" class="btn-landing">
        Selesai
      </div>
      <div @click="goBack()" class="btn-landing">Kembali</div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    async registerVendor() {
      const { query } = this.$store.state.landingpage
      let pageName = this.$route.path
      let isReview = false

      if (
        (pageName && pageName.split('/')[1] == 'review-from-landing-page') ||
        (pageName && pageName.split('/')[1] == 'review-landing-page')
      ) {
        isReview = true
      }

      if (query == 'bu') {
        await this.$store.commit('landingpage/COMBINE_LEGAL_DOC', {
          badan: 'bu',
          review: isReview,
        })
      } else {
        await this.$store.commit('landingpage/COMBINE_LEGAL_DOC', {
          badan: 'perorangan',
          review: isReview,
        })
      }

      if (isReview) {
        await this.$store.commit('landingpage/SEND_REGISTER_DATA', {
          process: 'review',
        })
      } else {
        await this.$store.commit('landingpage/SEND_REGISTER_DATA', {
          process: 'create',
        })
      }
    },
    goBack() {
      const { query } = this.$store.state.landingpage

      if (query == 'bu') {
        this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'legalitasbu')
      } else {
        this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'legalitas')
      }
    },
  },
}
</script>
